<template>
  <el-container style="height: 100vh">
    <el-aside width="200px" style="background: #001529">
      <div class="logo">管理后台</div>
      <el-menu
        :default-active="$route.path"
        background-color="#001529"
        text-color="#c9d1d9"
        active-text-color="#409eff"
        router
      >
        <el-menu-item index="/ad-slots"><i class="el-icon-video-camera"></i> 广告位管理</el-menu-item>
        <el-menu-item index="/users"><i class="el-icon-user"></i> 用户管理</el-menu-item>
        <el-menu-item index="/questions"><i class="el-icon-notebook-2"></i> 题库管理</el-menu-item>
        <el-menu-item index="/ad-view-records"><i class="el-icon-tickets"></i> 广告核销记录</el-menu-item>
        <el-menu-item index="/app-versions"><i class="el-icon-refresh"></i> 版本管理</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: #fff;
          border-bottom: 1px solid #eee;
        "
      >
        <span style="font-size: 16px; font-weight: 500">{{ $route.meta.title }}</span>
        <el-button size="small" @click="logout">退出登录</el-button>
      </el-header>
      <el-main style="background: #f5f5f5">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: "Layout",
  methods: {
    logout() {
      localStorage.removeItem("admin_token");
      this.$router.push("/login");
    },
  },
};
</script>

<style scoped>
.logo {
  color: #fff;
  text-align: center;
  line-height: 60px;
  font-size: 18px;
  font-weight: bold;
}
</style>
